import React, { ReactElement } from "react";
import { Navigate, useLocation, useSearchParams } from "react-router-dom";

interface IProtectedRoot {
  isAuth: boolean;
  children: ReactElement;
  redirectPath?: string;
}
function ProtectedRoute({
  isAuth,
  children,
  redirectPath = "/login",
}: IProtectedRoot): ReactElement {
  const location = useLocation();
  const [searchParams] = useSearchParams();


  return isAuth || (searchParams.get('Guid') || searchParams.get('guid')) ? (
    children
  ) : (
    <Navigate to={redirectPath} state={{ from: location.pathname }} replace />
  );
}

export default ProtectedRoute;
